/**
 * Utilidades generales para la aplicación
 */

/**
 * Formatea una fecha en formato legible
 * @param dateString - Cadena de fecha a formatear
 * @returns Fecha formateada en español
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

/**
 * Convierte la primera letra de una cadena a mayúscula
 * @param str - Cadena a capitalizar
 * @returns Cadena con la primera letra en mayúscula
 */
export const capitalize = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};